import request from "@/utils/request";

export function GetMenuWithOrders(
  branchId,
  kprice,
  startDate,
  endDate,
  fardId
) {
  return request({
    url: "/Order/GetMenuWithOrders",
    method: "post",
    data: {
      BranchId: branchId,
      KPrice: kprice,
      StartTarikh: startDate,
      EndTarikh: endDate,
      FardId: fardId,
    },
  });
}

export function GetDeliveryPlaceOrders(mealId, tarikh, deliveryPlaceID) {
  return request({
    url: "/Order/GetDeliveryPlaceOrders",
    method: "post",
    data: {
      MealId: mealId,
      Tarikh: tarikh,
      DeliveryPlaceId: deliveryPlaceID,
    },
  });
}

export function SaveOrder(kprice, deliveryPlaceID, orders, fardId) {
  return request({
    url: "/Order/Save",
    method: "post",
    data: {
      deliveryPlaceID: deliveryPlaceID,
      KPrice: kprice,
      Orders: orders,
      FardId: fardId,
    },
  });
}

export function SaveAndDeliver(fardId, deliveryPlaceID, orders) {
  return request({
    url: "/Order/SaveAndDeliver",
    method: "post",
    data: {
      deliveryPlaceID: deliveryPlaceID,
      fardId: fardId,
      Orders: orders,
    },
  });
}

export function Cancel(id) {
  return request({
    url: "/Order/Cancel",
    method: "post",
    data: {
      Id: id,
    },
  });
}

export function Delivery(orders) {
  return request({
    url: "/Order/Delivery",
    method: "post",
    data: orders,
  });
}

export function GetOrdersReport(branchId, deliveryPlaceID, startDate, endDate) {
  return request({
    url: "/Order/GetOrdersReport",
    method: "post",
    data: {
      BranchId: branchId,
      DeliveryPlaceId: deliveryPlaceID,

      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function GetAllOrders(branchId, fardId, startDate, endDate, skip) {
  let url = "/Order/GetAllOrders?$orderby=id desc";
  if (skip >= 0) {
    url += "&$top=10&$skip=" + skip;
  }
  return request({
    url: url,
    method: "post",
    data: {
      BranchId: branchId,
      fardId: fardId,
      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function GetUserOrders(branchId, startDate, endDate, skip) {
  return request({
    url: "/Order/GetUserOrders?$orderby=id desc&$top=10&$skip=" + skip,
    method: "post",
    data: {
      BranchId: branchId,
      StartTarikh: startDate,
      EndTarikh: endDate,
    },
  });
}

export function CalculateJarimeh(branchId) {
  return request({
    url: "/Order/CalculateJarimeh",
    method: "post",
    data: {
      Id: branchId,
    },
  });
}
